import type * as SentryType from '@sentry/browser';

let sentryPromise: Promise<typeof SentryType> | null = null;
let loadedSentry: typeof SentryType | null = null;

export const getSentry = (): Promise<typeof SentryType> => {
  if (!sentryPromise) {
    sentryPromise = import('@sentry/browser').then((mod) => {
      loadedSentry = mod;
      return mod;
    });
    // Reset the cache on failure so one transient chunk-load error doesn't
    // disable Sentry for the rest of the session.
    sentryPromise.catch(() => {
      sentryPromise = null;
    });
  }
  return sentryPromise;
};

/**
 * Fire-and-forget access to Sentry that never produces an unhandled
 * rejection — a rejected dynamic import would otherwise match the global
 * chunk-load-error handler and trigger a full page reload from the
 * error-reporting path. Runs synchronously when the module is already loaded.
 */
export const withSentry = (cb: (sentry: typeof SentryType) => void): void => {
  if (loadedSentry) {
    cb(loadedSentry);
    return;
  }
  getSentry()
    .then(cb)
    .catch(() => {});
};
